export default {"src":"/_next/static/media/mail.f026db9b.svg","height":72,"width":72};